import React, { useState } from "react";
import { HttpService } from "../../apiAuthorization/httpService";

export const AppSettingMenu = React.createContext(null);

export const AppSettingMenuContext = props => {
    const [appSettingMenus, setAppSettingMenus] = useState([]);

    const getAppSettingMenus = () => {
        HttpService.post("/Home/GetAppSettingMenus")
        .then((result) => {
            setAppSettingMenus(result.data);
        },
        (error) => {
            console.log(error);
        })
    };

    return (
        <>
            <AppSettingMenu.Provider value={{ appSettingMenus, getAppSettingMenus }}>{props.children}</AppSettingMenu.Provider>
        </>
    );
}
